import { Link } from "react-router-dom";
import { Eyebrow } from "@/components/Reveal";

export default function PaymentCancel() {
  return (
    <div className="pt-16 min-h-[80vh] flex items-center" data-testid="payment-cancel-page">
      <div className="max-w-xl mx-auto px-4 text-center py-24">
        <Eyebrow className="justify-center">Checkout Cancelled</Eyebrow>
        <h1 className="font-display font-extrabold uppercase text-3xl sm:text-5xl mt-4">The Bag Waits</h1>
        <p className="text-cream/50 text-sm mt-6 max-w-sm mx-auto leading-relaxed">
          Nothing was charged. Your pieces are still in your bag — limited runs don't wait forever though.
        </p>
        <Link to="/shop" className="inline-block mt-10 bg-gold text-noir-bg px-8 py-4 font-mono2 text-[10px] tracking-[0.25em] uppercase hover:bg-cream transition-colors" data-testid="cancel-shop-link">
          Return to the Drop
        </Link>
      </div>
    </div>
  );
}
